// extracted by mini-css-extract-plugin
export var colorSelect = "partition-page-module--colorSelect--4faaa";
export var form = "partition-page-module--form--e20ba";
export var label = "partition-page-module--label--4f05c";
export var radios = "partition-page-module--radios--886a8";